import { render, staticRenderFns } from "./lookSingleQuestion.vue?vue&type=template&id=64fe1d7f&scoped=true&"
import script from "./lookSingleQuestion.vue?vue&type=script&lang=js&"
export * from "./lookSingleQuestion.vue?vue&type=script&lang=js&"
import style0 from "./lookSingleQuestion.vue?vue&type=style&index=0&id=64fe1d7f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fe1d7f",
  null
  
)

export default component.exports